module.exports = __webpack_public_path__ + "img/logo.45be892f.svg";